module.exports = __webpack_public_path__ + "img/integrated.2a0c169c.svg";